'use client';

import { useQuery } from '@tanstack/react-query';
import { searchService } from '../services/searchService';

export const useSearch = (term: string) => {
	return useQuery({
		queryKey: ['search', term],
		queryFn: () => searchService.search(term),
		enabled: !!term,
	});
};
